'use strict';

var map = require('./map.json');

var convert = function (key) {
  var val = map[key.toLowerCase()];
  return val ? val : key;
};

module.exports = convert;
module.exports.convert = convert;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-attr-converter/index.js
 ** module id = 200
 ** module chunks = 0
 **/